import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

export interface QueryColumnPickerProps {
  columns: { name: string }[];
  selected: string[]; // empty = all
  onChange: (next: string[]) => void;
}

export function QueryColumnPicker({ columns, selected, onChange }: QueryColumnPickerProps) {
  const [filterText, setFilterText] = useState('');

  const toggle = (name: string) => {
    if (selected.includes(name)) onChange(selected.filter((c) => c !== name));
    else onChange([...selected, name]);
  };

  const needle = filterText.trim().toLowerCase();
  const visible = needle ? columns.filter((c) => c.name.toLowerCase().includes(needle)) : columns;

  return (
    <div className="space-y-2">
      <div className="flex items-center gap-2">
        <Input
          type="text"
          placeholder="Search columns…"
          value={filterText}
          onChange={(e) => setFilterText(e.target.value)}
          data-testid="column-search"
          className="h-8 max-w-xs"
        />
        <span data-testid="column-selected-count" className="text-xs text-muted-foreground">
          {selected.length} selected
        </span>
      </div>
      <div className="flex flex-wrap gap-2">
        {visible.map((c) => {
          const isSelected = selected.includes(c.name);
          return (
            <Button
              key={c.name}
              type="button"
              size="sm"
              variant={isSelected ? 'default' : 'outline'}
              data-testid={`column-toggle-${c.name}`}
              aria-pressed={isSelected}
              onClick={() => toggle(c.name)}
            >
              {c.name}
            </Button>
          );
        })}
      </div>
    </div>
  );
}
